import sliders from 'assets/core/js/page/cms/sliders'
import cards from 'assets/core/js/page/cms/cards'
import form from 'assets/core/js/page/cms/form'
import searchMobileActions from 'assets/core/js/page/search/base/search-mobile-actions'
import searchMobileRecap from 'assets/core/js/page/search/base/search-mobile-recap'
import newsletter from 'assets/core/js/module/newsletter'

export default (): void => {
  sliders()
  cards()
  form()
  newsletter()
  searchMobileRecap()
  searchMobileActions()
}
